import PostsBlock from "./PostsBlock";

export default PostsBlock;
